import React from 'react'
import orsLogo from './dragonfly-logo.png'
import './OrsHeader.css'

const OrsHeader = (props) => {
    return <div className="header"><img src={orsLogo} className="ors-logo" alt="logo" /></div>
};

export default OrsHeader